import { lazy, Suspense } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import ErrorBoundary from "@/components/ErrorBoundary";
import LandingPage from "@/pages/LandingPage";

// La app (Clerk + todas las páginas, ~2,9 MB) se descarga sólo al salir de las rutas públicas.
// La landing viaja en el bundle inicial y no espera a que Clerk resuelva la sesión: un visitante
// de sebbia.cl ve contenido sin haber pedido nada de la app.
const App = lazy(() => import("@/App"));
const LegalPage = lazy(() => import("@/pages/LegalPage"));

const Cargando = () => (
  <div className="flex min-h-screen items-center justify-center bg-slate-50" data-testid="app-loading-state">
    <p className="text-base text-slate-600" data-testid="app-loading-text">Cargando sesión...</p>
  </div>
);

export default function Root() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <Suspense fallback={<Cargando />}>
          <Routes>
            {/* Públicas: sin Clerk. Quien ya tiene sesión también ve la landing; "Ingresar" lleva a
                /login, que redirige al panel si la sesión existe. */}
            <Route path="/" element={<LandingPage />} />
            <Route path="/terminos" element={<LegalPage doc="terminos" />} />
            <Route path="/privacidad" element={<LegalPage doc="privacidad" />} />
            <Route path="*" element={<App />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </ErrorBoundary>
  );
}
